<script>
import Label from './Label.vue'
import * as categoryService from '../../../components/service/category.service';

export default {
    props: {
        item_key: {
        type: String,
        required: true,
        },
        item_value: {
        // type: Object || String,
        required: false,
        },
        item: {
        type: Object,
        required: true,
        },
        submitted: {
        type: Boolean,
        required: true,
        },
        validation: {
        type: Object,
        required: true,
        },
        selectedItem: {
        type: Object,
        required: false
        },
        last_updated: {
            type: Object,
            required: false
        },
        updateValue: {
            type: Function,
            required: true
        }
    },
    components: {
        Label
    },
    data() {
        return {
            value: this.item_value,
            options: [],
            d_check: this.selectedItem ? this.selectedItem[this.item.displayOn] : false
        };
    },
    computed: {
        display_none_check: {
            get: function () {
                return this.d_check;
            },
            set: function (newValue) {
                this.d_check = newValue;
            }
        }
    },
    watch: {
        last_updated: {
            handler(val) {
                if(val && this.item.displayOn && val.key == this.item.displayOn) {                    
                    this.display_none_check = JSON.stringify(val.value) == this.item.displayOnValue ? true : false;
                }
            },
            deep: true
        },
        item_value: {
            handler(val) {
                if(this.value != val) this.value = val;
            },
            deep: true
        },
        value(val) { 
            this.updateValue(this.item_key, val);
        },
        display_none_check(val) {
            this.item.display = this.item.displayOn && !val ? false : true
        }
    },
    methods: {
        selectedLocation(loc) {
            if(this.value.find(x => x.id == loc.id)) {
                this.value = this.value.filter(x => x.id != loc.id)
            } else {
                this.value.push(loc)
            }
        },
        async getOptions() {
            let filter = {
                "where": {
                "name": "Contact Us",
                "cmsId": this.$route.params.cmsId
                },
                "include": [
                {
                    "relation": "pages"
                }
                ]
            };

            filter = encodeURIComponent(JSON.stringify(filter));
            
            let data = await categoryService.getWithFilter(filter)

            let pages = data[0].pages;
            if(pages) this.options = pages.sort((a, b) => a.additionalProp1.position - b.additionalProp1.position)
            this.options = this.options.filter(x => x.active)
            // this.value = this.options.filter(x => x.id == this.item_value)[0]

        },
    },
    async mounted() {
        this.item.display = false
        await this.getOptions()
    }
};
</script>
<template>
    <div class="mb-3" :class="{ 'd-none': item.displayOn && !display_none_check}">
        <Label v-if="!item.hideLabel" :item="item"/>
        <div class="row col-12 p-0">
            <div v-for="option in options" v-bind:key="option.id" class="form-check col-4 mb-2">
                <div class="cards-scrollable-item"
                @click="selectedLocation(option)">
                    <a tabindex="0" role="button" class="quick-link-card">
                        <div class="quick-link-card-top join-the-practice">
                            <span class="svg-icon">
                                <img :src="option.additionalProp1 && option.additionalProp1.icon">
                            </span>
                        </div>
                        <div class="quick-link-card-bottom">
                            {{option.label}}
                            <div class="round">
                                <input class="form-check-input custom-input" type="checkbox" :id="option.id" :name="option.id"
                                    :value="!!value.find(x => x.id == option.id)"
                                    :checked="!!value.find(x => x.id == option.id)"
                                    @input="selectedLocation(option)"
                                >
                                <label :for="option.id"></label>
                            </div>
                        </div>
                       
                    </a>
                </div>
                <!-- <label :for="option.id" class="form-check-label font-weight-medium">{{option.title}}</label> -->
            </div>
        </div>

        <div v-if="submitted && validation.$error" class="invalid-feedback">
        <span v-if="!validation.required">This value is required.</span>
        </div>
    </div>
</template>

<style scoped>
.round {
  /* position: relative; */
  position: absolute;
    bottom: 2rem;
    left: 205px;
}

.round label {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
  height: 20px;
  left: 0;
  position: absolute;
  top: 0;
  width: 20px;
}

.round label:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: "";
  height: 6px;
  left: 4px;
  opacity: 0;
  position: absolute;
  top: 6px;
  transform: rotate(-45deg);
  width: 11px;
}

.round input[type="checkbox"] {
  visibility: hidden;
}

.round input[type="checkbox"]:checked + label {
  background-color: #005EB8;
  border-color: #005EB8;
}

.round input[type="checkbox"]:checked + label:after {
  opacity: 1;
}

.custom-input {
    position: absolute;
    bottom: 1em;
    right: 0;
}
.svg-icon {
    display: inline-block;
    position: relative;
}
.quick-link-card-top.join-the-practice {
    border-top: 4px solid;
    background-color: #ffffff;
}
.quick-link-card-top {
    height: 90px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.quick-link-card {
    display: block;
    width: 218px;
    /* height: 180px; */
    text-decoration: none;
    transition: transform .2s ease-in;
    outline: none;
    /* margin-bottom: 1em; */
}
.quick-link-card-bottom {
    height: 4em;
    padding: 14px 12px;
    padding-top: 0;
    color: #000;
    font-size: 14px;
    /* letter-spacing: 0; */
    /* line-height: 21px; */
    /* font-weight: 600; */
    background-color: #fff;
    text-align: center;
}
</style>